import axios from 'axios';
import { API_URL } from '../../../config';
import { storage } from '../../../helpers';

export const addRule = async ({ cif, partnerCIF, pointOfWork, department, category }) => {
    const token = storage.getToken();
    try {
      const response = await axios.post(
        `${API_URL}/nomenclatures/rules`,
        {
          cif,
          partnerCIF,
          pointOfWork,
          category,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      console.log('API Response:', response.data);
      return response.data;
    } catch (error) {
      if (error.response) {
        console.error('API Error Response:', error.response.data);
      } else {
        console.error('API Error:', error.message);
      }
      throw error;
    }
  };
